module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07520_banner_800x600.be881524.png";